import { Modal } from 'shared-ui';
import { useNavigate } from 'react-router-dom';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ReactComponent as NewDocumentIcon } from 'assets/icons/new-document.svg';
import { ReactComponent as WrongIcon } from 'assets/icons/wrong.svg';
import { AppRoute } from 'routing/AppRoute.enum';

import * as Styled from './LicenseModal.styles';
import { LicenseModalProps } from './LicenseModalContextController.types';

export const LicenseModal = ({ isModalOpen, onClose, canManageLicense, licenseStatus }: LicenseModalProps) => {
  const { formatMessage } = useLocale();
  const navigate = useNavigate();

  const isNotFound = licenseStatus === 'NOT_FOUND';

  const handleAddLicense = () => {
    onClose();
    navigate(`${AppRoute.profile}?openAddLicense=true`);
  };

  const getTitle = () => {
    if (isNotFound) {
      return formatMessage({ id: AppMessages['license.notFound.modal.title'] });
    }
    return formatMessage({ id: AppMessages['license.expired.modal.title'] });
  };

  const getDescription = () => {
    if (isNotFound) {
      return formatMessage({
        id: canManageLicense
          ? AppMessages['license.notFound.modal.description.admin']
          : AppMessages['license.notFound.modal.description'],
      });
    }
    return formatMessage({
      id: canManageLicense
        ? AppMessages['license.expired.modal.description.admin']
        : AppMessages['license.expired.modal.description'],
    });
  };

  return (
    <Modal
      open={isModalOpen}
      onClose={onClose}
      header={formatMessage({ id: AppMessages['license.expired.modal.header'] })}
      type="info"
      size="small"
    >
      <Styled.Wrapper>
        <Styled.Content>
          <Styled.IconWrapper>{isNotFound ? <WrongIcon /> : <NewDocumentIcon />}</Styled.IconWrapper>
          <Styled.Title>{getTitle()}</Styled.Title>
          <Styled.Description>{getDescription()}</Styled.Description>
          {canManageLicense && (
            <Styled.AddLicenseButton variant="contained" color="primary" size="small" onClick={handleAddLicense}>
              {formatMessage({ id: AppMessages['license.expired.modal.addLicense'] })}
            </Styled.AddLicenseButton>
          )}
        </Styled.Content>
      </Styled.Wrapper>
    </Modal>
  );
};
